import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import "./styles/common.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { NotificationContextProvider } from "./core/contexts/NotificationContext";
//import "./wdyr";

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.

root.render(
  <NotificationContextProvider><App /></NotificationContextProvider>, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
